{
  "satis_urun": {
    "Baslik": "Verkoopproducten",
    "Ad": "Productnaam",
    "Firma Adı": "Bedrijfsnaam",
    "Birim": "Valuta",
    "Komisyon": "Commissie",
    "Komisyon SM": "Commissie SM",
    "Durum": "Status",
    "Arama": "Zoeken",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Yenile": "Vernieuwen",
    "Data Yenile": "Gegevens Vernieuwen",
    "Ekle": "Toevoegen",
    "Filtrele": "Filteren",
    "Duzenle": "Bewerken",
    "Sil": "Verwijderen",
    "Kaydet": "Opslaan",
    "Guncelle": "Bijwerken",
    "Vazgec": "Annuleren",
    "Iptal": "Annuleren",
    "Birim Seçimi": "Valutaselectie",
    "TL": "TL",
    "Dolar": "Dollar",
    "Hepsi": "Alle",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "ARA": "Zoeken",
    "Komisyonlar": "Commissiebereiken",
    "Kopyalama": "Doel Kopiëren",
    "Kaynak Ürün": "Bronproduct",
    "Kaynak Ünvan": "Brontitel",
    "Hedef Ürün": "Doelproduct",
    "Hedef Ünvan": "Doeltitel",
    "KopyalaUyari": "Let op! Oude commissierecords in het doelproduct en titel worden verwijderd.",
    "Kopyala": "Kopiëren",
    "Islemler": "Acties"
  }
}
